import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Button, Fade, Tooltip } from "@mui/material";
import React, { useState } from "react";

import { Typography } from "new-components/typography/Typography";

interface CopyButtonProps {
  valueToCopy: string;
  buttonClassName?: string;
  iconClassName?: string;
  colorIcon?: string;
  text?: string;
}

export function CopyButton(props: CopyButtonProps) {
  const { valueToCopy, buttonClassName = "", colorIcon, text, iconClassName = "" } = props;
  const [copied, setCopied] = useState(false);
  const [copiedTimer, setCopiedTimer] = useState<number | undefined>();

  function copyValue(copiedValue: string) {
    clearTimeout(copiedTimer);
    setCopied(true);
    const tempCopiedTimer = window.setTimeout(() => {
      setCopied(false);
    }, 2000);
    setCopiedTimer(tempCopiedTimer);
    navigator.clipboard.writeText(copiedValue);
  }

  return copied ? (
    <Fade in={copied}>
      <Tooltip title="Copied!">
        <Button className={buttonClassName} onClick={() => copyValue(valueToCopy)}>
          <CheckIcon className={iconClassName} style={{ color: colorIcon || "green", marginRight: "10px" }} />
          {text && <Typography variant="small" noWrap color={colorIcon || "green"}>
            {text}
          </Typography>}
        </Button>
      </Tooltip>
    </Fade>
  ) : (
    <Tooltip title="Copy">
        <Button className={buttonClassName} onClick={() => copyValue(valueToCopy)}>
          <ContentCopyIcon className={iconClassName} style={{ color: colorIcon || "black", marginRight: "10px" }} />
          {text && <Typography variant="small" noWrap color={colorIcon || "black"}>
            {text}
          </Typography>}
        </Button>
    </Tooltip>
  );
}